{
  "About": "About",
  "EditAbout": "edit about",
  "about": "about",
  "teamRoles": "team roles",
  "Advisors": "Advisors",
  "TeamMemberTitle": "Team Member's Title",
  "Save": "Save",
  "noTitle": "no title yet",
  "Team": "Team",
  "Kudos": "Kudos",
  "BusinessCase": "Business Case",
  "Delete": "Delete ",
  "FormerRebel": "Former Rebel",
  "cancel": "cancel",
  "projectDescription": "Add a 1-3 sentence description about your project. You can use your value proposition developed in the solution challenge. Max 250 characters",
  "ChangesMade": "Changes Made",
  "ConfirmCancel": "Are you sure you want to cancel?",
  "goBack": "No, go back",
  "YesCancel": "Yes, cancel",
  "EmptyProjectDescription": "Hmmm... empty.  Declare your project to the rebel world.",
  "EmptyDescriptionPlaceHolder": "Add a 1-3 sentence description about your project. You can use your value proposition developed in the solution challenge. Max 250 characters.",
  "EmptyProjectDescriptionPart1": "Hmmm... empty. ",
  "DeclareYourProject": "Declare your project to the rebel world.",
  "ClickHere": "Click here ",
  "EmptyProjectDescriptionPart2": "and declare your project to the rebel world.",
  "EmptyProjectDescriptionPart3": "This description is a work in progress",
  "EmptyProjectDescriptionPart4": "( just like all of us )",
  "uploadBackdrop": "upload backdrop",
  "changeLogo": "change logo",
  "backdrop": "backdrop",
  "based": "based",
  "industry": "Industry",
  "Name": "Name",
  "stage": "stage",
  "description": "description",
  "ProjectDetails": "project details",

  "LoadingYourContent": "Loading your content...",
  "editTopic": "edit topic",
  "EditBackground": "Edit Background",
  "EditDetails": "Edit Details",

  "RequiredField": "This field is required",
  "MaximumLengthExceeded": "Maximum length is exceeded",
  "Brief": "Brief",
  "ProjectOwner": "Project Owner",
  "ProjectAdmin": "Project Admin",
  "ProjectMember": "Project Member",
  "ProjectSupporter": "Project Supporter",
  "Supporters": "Supporters",
  "Note": "Note",
  "Notes": "Notes",
  "TellMeWhatYouThink": "Tell me what do you think",
  "UnableToSaveProjectProfile": "Unable to save project profile"
}
